import { createFileRoute } from "@tanstack/react-router";

import { PaymentOrderList } from "../payment_orders/PaymentOrderList";
import { paymentOrdersQueryOptions } from "../payment_orders/queries";

export const Route = createFileRoute("/_auth/payment-orders/")({
  loader: ({ context }) =>
    context.queryClient.ensureQueryData(paymentOrdersQueryOptions),
  component: PaymentOrderList,
});
